import { render, staticRenderFns } from "./OutstandingMoney.vue?vue&type=template&id=bcf89bb4&"
import script from "./OutstandingMoney.vue?vue&type=script&lang=js&"
export * from "./OutstandingMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports